export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.slider_images = {...storeState.slider_images, ...payload};

  return newState;
};
